import HeaderLanding from './HeaderLanding';

export default HeaderLanding;
